<template>
	<div class="login">
		<div class="header_box">
			<span class="picBox"><img style="width:100%" src="../assets/img/h5_login.png" /></span>
			<span class="inliol">{{$t('other.a406')}}-{{$t('other.a407')}}</span>
		</div>
		<div class="main">
			<div class="typemn">
				<div class="bokjng">
					<div class="oibvk">{{$t('other.a406')}}--{{$t('other.a408')}}：</div>
					<!-- <div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a3369')}}</div>
					<div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a3370')}}</div> -->
					<div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a409')}}</div>
					<div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a410')}}</div>
					<div class="okhbvkf"><i class="iconfont icon-gou"></i>{{$t('other.a411')}}</div>
				</div>
				<span class="bcpic">
					<img style="width:100%" src="../assets/img/login_bc1.png" />
				</span>
				
			</div>
			<div class="bmunlu">
				<div class="ingui">
					<div class="titleDesc">{{$t('other.a420')}}</div>
					<div class="bhgkn">
						<div :class="{'onkg':true,'ybvjkf':radio == 1}"  @click="radio=1">{{$t('other.a421')}}</div>
						<div :class="{'onkg':true,'pnkn':radio == 2}"  @click="radio=2">{{$t('other.a422')}}</div>
					</div>
					<!-- 登录 -->
					<div class="inglknm" v-if="radio == 1">
						<el-input ref="inputRef" class="input-text" v-model="inputCount" @keyup.enter.native="getLogin"  :placeholder="$t('other.a423')">
							<span slot="prefix">{{$t('other.a425')}}</span>
						</el-input>
						<el-input  class="input-text" v-show="!isVisble" type='password' @keyup.enter.native="getLogin" v-model="inputPassword" :placeholder="$t('other.a424')">
							<span slot="prefix" >{{$t('other.a426')}}</span>
						</el-input>
					</div>

					<!-- 注册 -->
					<div class="inglknm" v-if="radio == 2">
						<el-select v-model="areaCode"  :placeholder="$t('other.a50')">
							<span slot="prefix">{{$t('other.a427')}}</span>
							<el-option
							v-for="item in distrisAread"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
						<el-input ref="inputRef"  class="input-text" v-model="registerForm.userId"   :placeholder="$t('other.a429')">
							<span slot="prefix" >{{$t('other.a478')}}：</span>
						</el-input>
						<el-input ref="inputRef" class="input-text" v-model="registerForm.user.userName"   :placeholder="$t('other.a430')">
							<span slot="prefix" >{{$t('other.a430')}}：</span>
						</el-input>
						<el-input  class="input-text" type='password'  v-model="registerForm.password" :placeholder="$t('other.a400')">
							<span slot="prefix" >{{$t('other.a400')}}：</span>
						</el-input>
						<el-input  class="input-text" type='password'  v-model="registerForm.secpassword" :placeholder="$t('other.a431')">
							<span slot="prefix" >{{$t('other.a431')}}：</span>
						</el-input>
						<div style="position:relative">
							<el-input ref="inputRef"  class="input-text" v-model="registerForm.emailCode"   :placeholder="$t('other.a432')">
							<span slot="prefix" >{{$t('other.a401')}}：</span>
							</el-input>
							<el-button class="btn" type="primary" size="mini" @click="sendCode()">{{$t('other.a402')}}<span v-show="countNum !== 120">({{countNum}})</span></el-button>
						</div>
						<el-input ref="inputRef" class="input-text" v-model="registerForm.user.invitationCode"   :placeholder="$t('other.a433')">
							<span slot="prefix" >{{$t('other.a434')}}：</span>
						</el-input>
					</div>

					<div style="text-align:right;margin:20px 0" v-if="radio == 1">
							<el-checkbox @change="rementber" v-model="checked">{{$t('login.remember_password')}}</el-checkbox>
					</div>


					<div class="oknoig">
						<el-button v-if="radio == 1" class="input-btn" type="primary" @click="getLogin()">{{$t('login.login')}}</el-button>
						<el-button v-if="radio == 2" class="input-btn" type="primary" @click="register()">{{$t('other.a435')}}</el-button>
					</div>
				</div>
			</div>
			
		</div>
		<div class="onkgn1"><img style="width:100%" src="../assets/img/demo01.png" /></div>
		<div class="onkgn2"><img style="width:100%" src="../assets/img/demo02.png" /></div>
		<div class="onkgn3"><img style="width:100%" src="../assets/img/demo03.png" /></div>
		<div class="onkgn4"><img style="width:100%" src="../assets/img/demo04.png" /></div>
		
		<!-- <div class="ttp">
				<div class="login-box" v-if="islogin">
					<div class="login-box-header">
						<h2 style="color: #FFFFFF;" >{{$t('login.system')}}</h2>
						<div class="login-header">
							<el-select style="width: 120px;" size="mini" @change="switchLangq(value)" v-model="value" placeholder="Language">
								<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="login-main">
						<el-input ref="inputRef" class="input-text" v-model="inputCount" @keyup.enter.native="getLogin"  :placeholder="$t('login.account')"></el-input>
						<el-input  class="input-text" v-show="!isVisble" type='password' @keyup.enter.native="getLogin" v-model="inputPassword" :placeholder="$t('login.passsword')"></el-input>
						<el-input  class="input-text" v-show="isVisble" type='password' @keyup.native='remberPws' @keyup.enter.native="getLogin"  v-model="inputPassword" :placeholder="$t('login.passsword')"></el-input>
						<div style="width: 300px;">
							<el-checkbox @change="rementber" v-model="checked">{{$t('login.remember_password')}}</el-checkbox>
						</div>
						<div style="width: 100%;display: flex;justify-content: flex-end;align-items: center;">
							<router-link style="font-size: 14px; text-decoration: none; color: #000; margin-left: 10px;"  :to="{path:'/personal-account',query:{key:'resetLoginPws'}}">{{$t('login.forget')}}</router-link>
							<span style="font-size: 14px;padding: 0 20px;cursor: pointer;"  @click="gotoregistor">{{$t('login.registor')}}</span>
						</div>
						<el-button class="input-btn" type="primary" @click="getLogin">{{$t('login.login')}}</el-button>
					</div>
				</div>
			</div> -->
		</div>
	
	
</template>

<script>
	import md5 from 'js-md5';
	import {mapState, mapActions , mapMutations} from 'vuex'
	import newOrders from '@/api/moudles/newOrders' 
    import api from '../api/moudles/shopaccess'
	export default{
		data() {
			return{
				radio:1,
				emailCode:null,
				isPhone:false,
				registor_inputCountID:'',
				registor_inputusername:'',
				registor_password:'',
				registo_comfirPws:'',
				inputCount: '' ,
				value3:false,
				isVisble:false,
				countNum:120,
				// 用于倒计时标记，true-正在倒计时
				countFlag:false,
				// 定时器
				intervalBtn:{},
				//默认按钮的值
				btnMsg:this.$t('other.a436'),
				//手机号码
				mobile:"",

				inputPassword:'',
				start_time:'',
				end_time:'',
				options: [{
				          value: 'zh',
				          label: '中文'
				        }, {
				          value: 'en',
				          label: 'English'
				 }],
				 value: '',
				 checked:false,
				 areaCode:'+86',
				 islogin:true,
				 registerForm:{
					 emailCode:null,
					 partnerId:null,
					 password:null,
					 secpassword:null,
					 userId:null,
					 user:{
						 invitationCode:null,
						 partnerId:null,
						 userId:null,
						 userPhone:null,
						 userPos:'SELLER',
						 userEmail:null
					 }
				 },
				 distrisAread:[{
                        value: '+86',
                        label: 'China(+86)'
                    },{
                        value: '+63',
                        label: 'Philippines(+63)'
				 }, {
                        value: '+65',
                        label: 'Singapore(+65)'
				 }, {
                        value: '+84',
                        label: 'Vietnam(+84)'
				 },{
                        value: '+60',
                        label: 'Malaysia(+60)'
				 },{
                        value: '+34',
                        label: 'Spain(+34)'
				 },{
                        value: '+62',
                        label: 'Indonesia(+62)'
				 },{
                        value: '+66',
                        label: 'Thailand(+66)'
				 },{
                        value: '+351',
                        label: 'Portugal(+Portugal)'
				 }],
			}
		},
		computed:{
			...mapState({
				userInfo:state =>state.login.userInfo,
				loginStatus:state =>state.login.loginStatus,
				hasLogin:state =>state.login.hasLogin
			})
		},
		watch:{
			hasLogin(){
				setInterval(() =>{
					this.gotoindex()
				},500)
				
			},
			
		},
		
		created(){
			this.init()
			var paraString = location.search;
            if(paraString!=''){
                var result = paraString.replace("?","")
            
                var paras = result.split("&=");
                console.log(paras)
                this.inputCount = paras[0]
                this.inputPassword = paras[1]
                this.getLogin();
            }
		},
		mounted(){
		this.$refs.inputRef.focus()

		},
	
		  
	
		methods:{
			...mapActions('login',[
				'getLoginIn',
				'getEmailCode',
				'getRegister'
			]),
			...mapActions('order', [
				'getunprocessOrder',
				'auditOrder',
				'getunprocessOrderByshopId'
			]),
			...mapMutations('login', [
				'SWITCH_LANG',
			]),

			

			
			
			remberPws(){
				console.log(111)
					const userCount={
						account:this.inputCount,
						passsword:md5(this.inputPassword + 'seller')
					}
					localStorage.setItem('userCount',JSON.stringify(userCount))
			},
			
			
	
			
			//记住密码
			rementber(){
				if(!this.inputCount || !this.inputPassword){
					this.$message.error(this.$t('other.a437'))
					return
				}
				if(this.checked) {
					const userCount={
						account:this.inputCount,
						passsword:this.inputPassword 
					}
					localStorage.setItem('userCount',JSON.stringify(userCount))
				}else{
					localStorage.removeItem('userCount')
				}
				
			},
			init(){
			
				let account=JSON.parse(localStorage.getItem('userCount'))
				if(account){
					this.checked=true
					this.inputCount=account.account
					this.inputPassword=account.passsword
				}else{
					this.checked=false
				}
			},
		
			getCookie(cname) {
				var name = cname + "=";
				var ca = document.cookie.split(';');
				console.log("获取cookie,现在循环")
				for (var i = 0; i < ca.length; i++) {
				  var c = ca[i];
				  console.log(c)
				  while (c.charAt(0) == ' ') c = c.substring(1);
				  if (c.indexOf(name) != -1){
					return c.substring(name.length, c.length);
				  }
				}
				return "";
			  },

			//检查输入的帐号是否是邮箱格式
			vertifyEmail(){
				var email = this.registerForm.userId;
				var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
				if(email){
					if(reg.test(email)){
						console.log('text','邮箱格式')
						this.isPhone=false
					}else{
						console.log('text','手机号码')
						this.isPhone=true
					}
				}
			},

			countDown(){
                // 设置btn倒计时时显示的信息
                this.btnMsg = null;
                // 更改btn状态
                this.countFlag =! this.countFlag;
                // 设置倒计时
                this.intervalBtn = setInterval(() => {
                    if(this.countNum <= 0) {
                        // 重置btn提示信息
                        this.btnMsg = this.$t('other.a436');
                        // 清除定时器
                        clearInterval(this.intervalBtn)
                        // 更改btn状态
                        this.countFlag =! this.countFlag;
                        // 重置倒计时状态
                        this.countNum = 121;
                    };
                    // 倒计时
                    this.countNum -- ;
                }, 1000);
            },


			sendCode(){
				this.vertifyEmail()
				if(this.isPhone){
                    if(!this.registerForm.userId){
                        this.$message.warning(this.$t('other.a452'))
                        return
                    }

					let myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/

					if (!myreg.test(this.registerForm.userId)) {
						this.$message.warning(this.$t('other.a479'))
						return
					} 

					


                    newOrders
                    .getPhoneCode({
                        country:this.areaCode,
                        phone:this.registerForm.userId
                    })
                    .then(res => {
                    if(res.code === 200 ){
                    
                    this.$message.success(this.$t('other.a440'))
					this.countDown()
                    }else{
                    this.$message.warning(res.msg)
					this.countDown()
                    }
                    })
                }else{
					
					if(!this.registerForm.userId){
                        this.$message.warning(this.$t('other.a441'))
                        return
                    }

					this.getEmailCode({email:this.registerForm.userId})
					
				}
			},
			register(){

				console.log(this.registerForm)
				
				if(!this.registerForm.userId){
					this.$message.warning(this.$t('other.a442'))
					return
				}else if(!this.registerForm.user.userName){
					this.$message.warning(this.$t('other.a447'))
					return
				}else if(!this.registerForm.passsword == null){
					this.$message.warning(this.$t('other.a443'))
					return
				}else if(!this.registerForm.emailCode){
					this.$message.warning(this.$t('other.a444'))
					return
				}

				if(this.registerForm.password !== this.registerForm.secpassword){
					this.$message.warning(this.$t('other.a445'))
					return
				}


				
				this.registerForm.user.userId=this.registerForm.userId
				this.registerForm.user.userPhone=this.registerForm.userId

				let obj=JSON.parse(JSON.stringify(this.registerForm))
				obj.password=md5(obj.password+'seller')

				console.log(this.registerForm)
				console.log('obj',obj)

				if(this.isPhone){//手机注册
					newOrders
					.phoneRegister(obj)
					.then(res => {
					if(res.code === 200 ){
					this.$message.success(this.$t('other.a446'))
					
					}else{
					this.$message.warning(res.msg)
					}
					})
				}else{
					if (!obj.user.invitationCode ) {
						this.$confirm(this.$t('other.a3371'),this.$t('other.a142'), {
						confirmButtonText: this.$t('other.a5'),showCancelButton:false,
						type: 'warning'
						}).then(() => {
						})
						return;
					}
					if (!obj.user.userPhone) {
					this.$message.warning(this.$t('other.a458'));
					return;
					}
					this.getRegister(obj).then(res => {
					if(res == 'hasSuccess'){
						console.log('111')
					}
					})
				}
			



				
			},  
			
			getLogin(){
				 
				
                    let  params={
                    userId :this.inputCount.replace(/\s*/g,""),
                    token:this.inputPassword
                    
                    }

                    localStorage.setItem('userInfo',JSON.stringify(params))
					   
				   
					
					

                    api
                    .getUserInfo({userId:JSON.parse(localStorage.getItem('userInfo')).userId})
                    .then(res => {
                        if(res.code === 200){
                            console.log('重新获取一次帐号的信息',res.data)
                           
                            let data=res.data
                            if(data.shopeeShops || data.lazadaShops || data.tiktokShops){
                                localStorage.setItem('shophasAuthorization', true)
                            }else{
                                localStorage.setItem('shophasAuthorization', false)
                            }
                            if(data.userPos=== 'STORE'){
                                localStorage.setItem('shophasAuthorization', true)
                                
                            }
                            localStorage.setItem('userInfo', JSON.stringify(data))
                            localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
                            localStorage.setItem('warehouse', JSON.stringify(data.stores))
                            localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
							localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
                            this.$message.success(this.$t('other.a480'))
                            setTimeout(()=> {
                                setTimeout(()=> {
									if(res.data.userPos == 'SELLER' && res.data.vipLevel == 0){
										location.replace('/index')
									}
									if(res.data.userPos == 'STORE' && res.data.vipLevel == 0){
										location.replace('/sellerManagement')
									}
									if(res.data.vipLevel == 1){
										location.replace('/stockProduct/single')
									}
								},1000)
                            
                            },500)
                        } 
                    })
					// if(event.keyCode == 13) {
					// 	this.getLoginIn(params)
					// 	return
					// }
					// this.getLoginIn(params)
					// setTimeout(()=> {
					// 	if(this.loginStatus) {
					// 		location.replace('/index')
					// 	}
					// },500)
			},
			gotoregistor(){
				let url=location.href
				console.log(url)
				if(url.indexOf('dianxiaosheng') > -1) {//普通用户
					this.$router.push('/registor')
				}else if(url.indexOf('weanaly') > -1){//印尼用户跳转
					this.$router.push('/registorpage')
				}else if(url.indexOf('shopsbu') > -1){//印尼用户跳转
					this.$router.push('/registor')
				}else{
					this.$router.push('/registor')
				}
				
				
			},
			gotoindex(){
				location.replace('/index')
			},
			switchLangq(value){
				this.SWITCH_LANG(value)
				this.$i18n.locale =  value 
				
			},
	

		}
	}
</script>

<style lang="scss" scoped>



	.login{
		position: absolute;
		width: 100%;
		height: 100vh;
		background-color: #fff;
		background-image: url(../assets/img/login_bg_2e996a1.png);
		background-repeat:no-repeat; 
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
		z-index: 2000;

		.onkgn1{
			position: absolute;
			top: 80px;
			left: 30%;
			width:250px;
		}


		/deep/ .el-input__prefix {
			line-height: 40px;
			color: #000;
		}

		.btn{
			position: absolute;
			right: 5px;
			top:16px

		}

		.onkgn2{
			position: absolute;
			bottom: 122px;
			left: 100px;
			width:304px;
		}


		.onkgn3{
			position: absolute;
			bottom: 80px;
			right: 0;
			width:304px;
		}

		.onkgn4{
			position: absolute;
			bottom: 600px;
			right: 100px;
			width:304px;
		}

		

		.oknoig{
			text-align: center;
		}



		.header_box{
			padding: 10px 50px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			


			.picBox{
				display: inline-block;
				width: 50px;
				height: 50px;
				overflow: hidden;
			}


			.inliol{
				font-size: 20px;
				font-weight: bold;
				padding-left: 20px;
			}
		}


		/deep/ .el-input{
			width: 330px;
		}




		

		/deep/ .el-input__inner{
			padding-left: 90px;
		}


		.icon-tubiao{
			font-size: 20px;
			line-height:40px
		}

		.icon-tubiao::after{
			content: "|";
			padding: 0 10px;
			height: 10px;

		}


		.main{
			// display: flex;
			// position: fixed;
			// top: 60px;
			// left: 0;
			// right: 0;
			// bottom: 0;
			
			

			.typemn{
				width: 60%;
				position: relative;

				.bcpic{

					width: 558px;
					overflow: hidden;
					position: fixed;
					bottom: 240px;
					left: 20%;
				}

				.bokjng{
					position: absolute;
					top: 123px;
					left: 100px;
					z-index: 99;

				}

				.oibvk{
					    font-size: 32px;
						font-weight: bold;
						color: #66b1ff;
						margin-bottom: 35px;

				}

				.okhbvkf{
					margin-bottom: 40px;
					font-size: 23px

				}

				.icon-gou{
					color: rgb(1, 191, 126);
					margin-right: 10px;
				}
			}

			.bmunlu{
				margin-top: 65px;
				z-index: 999;

				.ingui{
					width: 330px;
					box-shadow: 0px 0px 20px 0px rgba(153,169,191,20%);
					padding: 0 15px;
					border-radius: 5px;
					


					.titleDesc{
						font-size: 25px;
						text-align: center;
						padding: 40px 0 20px 0;
						color: #66b1ff;
					}



					.bhgkn{
						display: flex;
						width: 100%;
						justify-content: space-between;
						margin: 10px 0 20px 0;
						position: relative;

						.onkg{
							width: 50%;
							text-align: center;
							padding-bottom: 8px;
							color:#99a9bf;
							cursor: pointer;
						}

						.ybvjkf{
							color: #000;
						}

						

						.ybvjkf::after{
							content: "";
							width: 50%;
							height: 0.5px;
							background-color: #66b1ff;
							position: absolute;
							bottom: 0;
							left: 0;
						}

						.pnkn{
							color: #000;
						}

						

						.pnkn::after{
							content: "";
							width: 50%;
							height: 0.5px;
							background-color: #66b1ff;
							position: absolute;
							bottom: 0;
							right: 0;
						}


					}

					.inglknm{
						display: flex;
						flex-direction: column;
						justify-content: center;
					}
				}
			}
		}
		

	}
	
	.tologin{
		margin-bottom: 30px;
		cursor: pointer;
	}
	
	.login-box{
		
		   
		  
		  width: 438px;
		  border-radius: 10px;
		  background: #fff;
		  box-shadow: 0 0 25px #cac6c6;

	}
	.login-desc{

		width: 600px;
		height: 480px;
		background-color: #333536;
		opacity: 0.8;
		color: #fff;
		border-radius: 10px;
		box-sizing: border-box;
		padding: 20px 20px;
		z-index: -1;
	}
	.login-left,.login-right{
		width: 50%;
	}
	.pic-box{
		display: inline-block;
		width:155px;
		height: 155px;
	}
	
	.ppt{
		display: flex;
		justify-content:space-between;
		margin: 40px 0;
		
	}
	
	.login-title{
	
		font-size: 20px;
		font-weight: bold;
	}
	
	.input-text{
	
		width: 300px;
		margin: 10px 0;
	}
	
	.login-left,.login-right{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.registor{
		width: 80%;
		text-align: right;
		cursor: pointer;
	}
    .login-header{
		    position: absolute;
		    top: 10px;
		    right: -140px;
	}
	
/* 	.login-wrapper{
		margin-top: 74px;
	
	} */
	
	
	.login-box-header{
		position: relative;
		height: 200px;
		background-image: url(../assets/img/login_01.png);
		background-repeat:no-repeat;
		background-size:100%;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.login-main{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.input-btn{
		width: 200px;
		border-radius: 30px;
		margin-top: 20px;
		margin-bottom: 50px;
	}
	
	.login-item{
		display: inline-block;
		margin: 10px 0;
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
	}
	
	.login-desc-item{
		font-weight: bold;
		line-height: 50px;
		margin-bottom: 20px;
	}
	
	.login .ttp{
		width: 100%;
		display: flex;
		justify-content: space-around;
		box-sizing: border-box;
		padding: 100px 0;
		
		
	}
	
	.ppt-item{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 50px;
		height: 50px;
	}
</style>
